export default "__VITE_ASSET__533c0a37__"